module.exports = __webpack_public_path__ + "static/home_item_d-794358deaac96296a6471bf0c97e91ca.jpg";